import { useState } from 'react'
import RecipeSection from './RecipeSection'
import ExploreSection from './ExploreSection'
import PromptInput from './PromptInput'
import type { HomeTab } from './types'
import { RecipeItem } from './mockData'

interface RightContentProps {
  activeTab: HomeTab
}

export default function RightContent({ activeTab }: RightContentProps) {
  const [selectedRecipe, setSelectedRecipe] = useState<RecipeItem | null>(null)

  if (activeTab === 'projects') {
    // Mock project data
    const projects = [
      {
        id: 1,
        title: 'G8元首的新年七大祝八大祝福',
        thumbnail:
          'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&h=450&fit=crop&q=80',
        editedTime: '2 hours ago',
      },
      {
        id: 2,
        title: '可爱挖掘机大冒险：幼儿园乐趣探索',
        thumbnail:
          'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&h=450&fit=crop&q=80',
        editedTime: '2 hours ago',
      },
      {
        id: 3,
        title: 'Unleashing the Power of iPhone Innov...',
        thumbnail:
          'https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?w=800&h=450&fit=crop&q=80',
        editedTime: '3 hours ago',
      },
    ]

    return (
      <div className="h-screen overflow-y-auto bg-[#F4F4F5]">
        <div className="mx-auto max-w-7xl px-8 py-10">
          <h1 className="mb-8 text-3xl font-semibold text-gray-900">Projects</h1>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {projects.map((project) => (
              <div
                key={project.id}
                className="group cursor-pointer overflow-hidden rounded-2xl bg-white transition-shadow hover:shadow-lg"
              >
                {/* Thumbnail */}
                <div className="aspect-video w-full overflow-hidden bg-gray-100">
                  <img
                    src={project.thumbnail}
                    alt={project.title}
                    className="h-full w-full object-cover transition-transform group-hover:scale-105"
                  />
                </div>

                {/* Project Info */}
                <div className="p-4">
                  <h3 className="mb-2 line-clamp-2 text-base font-medium text-gray-900">
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-500">Edited {project.editedTime}</p>
                </div>
              </div>
            ))}
          </div>

          {/* End Message */}
          <div className="mt-12 text-center">
            <p className="text-sm text-gray-400">You&apos;ve reached the end</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen overflow-y-auto bg-[#F4F4F5]">
      <div className="mx-auto max-w-7xl px-8 py-12">
        {/* Header Section */}
        <div className="mx-auto mb-10 max-w-5xl text-center">
          {/* Subtitle */}
          <p className="mb-4 text-lg font-medium text-gray-400">
            Make great videos by chatting with AI
          </p>

          {/* Title */}
          <h1 className="mb-12 text-6xl font-bold tracking-tight text-gray-900">
            One Click to <span className="font-serif font-normal italic">Pro Videos</span>
          </h1>

          {/* Search Input Area */}
          <PromptInput selectedRecipe={selectedRecipe} onClearRecipe={() => setSelectedRecipe(null)} />
        </div>

        {/* Recipe Section */}
        <RecipeSection onUseRecipe={setSelectedRecipe} />

        {/* Explore Section */}
        <ExploreSection />
      </div>
    </div>
  )
}
